'use strict';

import angular from 'angular';

export default angular.module('storageApp.filters.category', [])
  .filter('renderCategory', function(Storage, $sce){
    'ngInject';

    var getById = function(id){
      return Storage.getCategories()
        .filter(category => {
          return id == category._id;
        }).shift();
    };

    var getFullPath = function(category) {
      var names = [];

      while(category){
        names.push(category.name);
        category = getById(category.parentId);
      }

      return names.reverse().join('/');
    };

    return function (input, raw) {
      var category = getById(input);
      
      if( ! category){
        return;
      }

      var fullPath = getFullPath(category);

      if(raw){
        return fullPath;
      }

      return $sce.trustAsHtml('<span title="' + fullPath + '">' + category.name + '</span>');
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/filters/category.js